export { default } from './carousel-controls.component'
export type { ControlsProps } from './carousel-controls.component'
